import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';



@Component({
  selector: 'wl-search-input',
  templateUrl: './search-input.component.html',
  styles: []
})
export class SearchInputComponent implements OnInit {
  searchControl: UntypedFormControl;
  @Output() searchValueChanged: EventEmitter<string> = new EventEmitter();


  constructor(private formBuilder: UntypedFormBuilder) {
    this.searchControl = this.formBuilder.control('');
    this.searchControl.valueChanges.pipe(
      debounceTime(300)
    ).subscribe((value) => {
      this.searchValueChanged.emit(value);
    });
   }


  ngOnInit() {
  }

}
